if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}

/* ODVARO: wyszukiwarka marek w filtrze "Marka" */
(function () {
  if (window.__ovBrandSearch) return;
  window.__ovBrandSearch = true;

  var FILTER_NAME = 'filter.p.vendor';

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .replace(/ł/g, 'l')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function apply(list, box, query) {
    var q = norm(query);
    var shown = 0;
    list.querySelectorAll('li').forEach(function (li) {
      var label = li.querySelector('.facet-checkbox__text-label');
      if (!label) return;
      var match = !q || norm(label.textContent).indexOf(q) !== -1;
      li.classList.toggle('ov-search-hide', !match);
      li.classList.toggle('ov-search-show', !!q && match);
      if (match) shown++;
    });
    var scope = list.closest('details') || list.parentNode;
    scope.classList.toggle('ov-searching', !!q);
    box.querySelector('.ov-facet-search__empty').hidden = !(q && shown === 0);
  }

  function init() {
    document.querySelectorAll('input[name="' + FILTER_NAME + '"]').forEach(function (inp) {
      var list = inp.closest('ul');
      if (!list || list.getAttribute('data-ov-search')) return;
      list.setAttribute('data-ov-search', '1');

      var box = document.createElement('div');
      box.className = 'ov-facet-search';
      box.innerHTML =
        '<input type="search" class="ov-facet-search__input" placeholder="Szukaj marek" aria-label="Szukaj marek" autocomplete="off" enterkeyhint="search">' +
        '<p class="ov-facet-search__empty" hidden>Nie znaleziono marki</p>';
      list.parentNode.insertBefore(box, list);

      var field = box.querySelector('input');
      ['input', 'change', 'search'].forEach(function (type) {
        field.addEventListener(type, function (e) {
          e.stopPropagation(); // nie odpalaj przeładowania filtrów
          apply(list, box, field.value);
        });
      });
      field.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') e.preventDefault();
      });
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      init();
    });
  }

  function start() {
    init();
    document.querySelectorAll('.facets-container').forEach(function (el) {
      new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ODVARO: suwak ceny w filtrze */
if (!customElements.get('ov-price-slider')) {
  class OvPriceSlider extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.max = Number(this.dataset.max) || 1000;
      this.steps = 1000;
      this.gap = 10;
      this.rMin = this.querySelector('.ov-price__range--min');
      this.rMax = this.querySelector('.ov-price__range--max');
      this.fill = this.querySelector('.ov-price__fill');
      const root = this.closest('price-range') || this.parentElement;
      const fields = root.querySelectorAll('input.field__input');
      this.fMin = fields[0];
      this.fMax = fields[1];
      if (!this.rMin || !this.rMax || !this.fMin || !this.fMax) return;

      this.syncFromFields();
      this.rMin.addEventListener('input', (e) => { e.stopPropagation(); this.onSlide('min'); });
      this.rMax.addEventListener('input', (e) => { e.stopPropagation(); this.onSlide('max'); });
      this.rMin.addEventListener('change', (e) => { e.stopPropagation(); this.commit(this.fMin); });
      this.rMax.addEventListener('change', (e) => { e.stopPropagation(); this.commit(this.fMax); });
      [this.fMin, this.fMax].forEach((f) => f.addEventListener('change', () => this.syncFromFields()));
    }

    // Skala nieliniowa: więcej miejsca na tańsze odlewki, gdzie jest większość produktów
    toPrice(pos) {
      return Math.round(this.max * Math.pow(pos / this.steps, 2.5));
    }

    toPos(price) {
      if (!(price > 0)) return 0;
      return Math.round(this.steps * Math.pow(Math.min(price, this.max) / this.max, 1 / 2.5));
    }

    parse(value) {
      return Number(String(value || '').replace(/\s/g, '').replace(',', '.'));
    }

    syncFromFields() {
      const a = this.parse(this.fMin.value);
      const b = this.parse(this.fMax.value);
      this.rMin.value = this.fMin.value === '' || !isFinite(a) ? 0 : this.toPos(a);
      this.rMax.value = this.fMax.value === '' || !isFinite(b) || b <= 0 ? this.steps : this.toPos(b);
      this.paint();
    }

    onSlide(which) {
      let a = Number(this.rMin.value);
      let b = Number(this.rMax.value);
      if (a > b - this.gap) {
        if (which === 'min') {
          a = Math.max(0, b - this.gap);
          this.rMin.value = a;
        } else {
          b = Math.min(this.steps, a + this.gap);
          this.rMax.value = b;
        }
      }
      this.fMin.value = a <= 0 ? '' : this.toPrice(a);
      this.fMax.value = b >= this.steps ? '' : this.toPrice(b);
      this.paint();
    }

    paint() {
      const a = (Number(this.rMin.value) / this.steps) * 100;
      const b = (Number(this.rMax.value) / this.steps) * 100;
      this.fill.style.left = a + '%';
      this.fill.style.right = 100 - b + '%';
      this.rMin.style.zIndex = Number(this.rMin.value) > this.steps * 0.9 ? 3 : 1;
    }

    commit(field) {
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  customElements.define('ov-price-slider', OvPriceSlider);
}
